<template>
    <TableComponent
        v-if="rowsData.length"
        v-bind:data="rowsData"
    >
        <template v-for="header in headers">
            <TableColumn
                v-bind:key="header.show"
                v-bind:show="header.show"
                v-bind:sort-by="header['sort-by']"
                v-bind:label="header.label"
                v-bind:data-type="header['data-type']"
                v-bind:hidden="header.hidden"
            ></TableColumn>
        </template>
    </TableComponent>
</template>

<script>
import { TableComponent, TableColumn } from 'vue-table-component';
var moment = require('moment');

export default {
    name: 'DERowsTable',
    components: {
        TableComponent,
        TableColumn
    },
    props: {
        rows: {
            type: Array,
            default: () => []
        },
        fields: {
            type: Array,
            default: () => []
        }
    },
    data: function() {
        //console.log(this.rows);
        //console.log(this.fields);
        return {
            headers: [],
            rowsData: []
        };
    },
    mounted: function() {
        this.setRowsData();
    },
    watch: {
        rows: function() {
            this.setRowsData();
        }
    },
    methods: {
        setRowsData: function() {
            //console.log('this.rows', JSON.stringify(this.rows, null, 2));
            //console.log('this.fields', JSON.stringify(this.fields, null, 2));
            if (this.rows.length) {
                //
                // Make headers...
                this.headers = Object.keys(this.rows[0]).map((k) => {
                    return {
                        show: k,
                        header: k
                    };
                });

                //
                // Copy row prop to internal array
                // - Attempt to convert sfmc formatted date fields to iso 8601
                var columnTypes = {};
                this.rowsData = this.rows.map((row) => {
                    row = JSON.parse(JSON.stringify(row));
                    Object.keys(row).forEach((k) => {
                        if (String(row[k]).match(/^([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{4})\s+([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})\s+(am|AM|pm|PM)$/)) {
                            row[k] = moment(row[k], 'M/D/YYYY h:m:s a').format('YYYY-MM-DDTHH:mm:ss');
                        }

                        if (!columnTypes[k]) {
                            columnTypes[k] = {
                                isInt: true,
                                isFloat: true,
                                isPct: true
                            }
                        }
                        if (String(parseInt(row[k])) != String(row[k])) {
                            columnTypes[k].isInt = false;
                        }
                        if (String(parseFloat(row[k])) != String(row[k])) {
                            columnTypes[k].isFloat = false;
                        }
                        if (!String(row[k]).match(/%$/)) {
                            columnTypes[k].isPct = false;
                        }
                    });
                    return row;
                }).map((row) => {
                    Object.keys(row).forEach((k) => {
                        if (columnTypes[k].isInt) {
                            row[k] = parseInt(row[k]);
                        } else if (columnTypes[k].isFloat) {
                            row[k] = parseFloat(row[k]);
                        } else if (columnTypes[k].isPct) {
                            row[`_sort_by_${k}`] = parseFloat(String(row[k]).replace(/%$/, ''));
                        }
                    });
                    return row;
                });

                var headersHidden = [];
                Object.keys(columnTypes).forEach((k) => {
                    var header = this.headers.find((header) => (header.show == k));
                    var columnType = columnTypes[k];
                    var headerSortByKey = `_sort_by_${k}`;
                    var headerHidden = null;
                    
                    if (columnType.isFloat || columnType.isInt) {
                        header['data-type'] = 'numeric';
                    } else if (columnType.isPct) {
                        headerHidden = {
                            show: headerSortByKey,
                            header: headerSortByKey,
                            'data-type': 'numeric',
                            hidden: true
                        };
                    }

                    if (!header['data-type']) {
                        header['data-type'] = 'text';
                    }

                    header.hidden = false;

                    if (headerHidden) {
                        header['sort-by'] = headerSortByKey;
                        headersHidden.push(headerHidden);
                    }
                });
                this.headers = this.headers.concat(headersHidden);
                //console.log(JSON.stringify(this.headers, null, 4));
            } else  {
                this.headers = [];
                this.rowsData = [];
            }
            //console.log('this.headers', JSON.stringify(this.headers, null, 2));
            //console.log('this.rowsData', JSON.stringify(this.rowsData, null, 2));
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.table-component {
  display: flex;
  flex-direction: column;
  margin: 4em 0;
  &,
  &:after,
  &:before,
  *,
  *:after,
  *:before {
    position: relative;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
}

.table-component__filter {
  align-self: flex-end;
}

.table-component__filter__field {
  padding: 0 1.25em 0 .75em;
  height: 2.5em;
  border: solid 2px #e0e0e0;
  border-radius: 2em;
  font-size: inherit;
}

.table-component__filter__clear {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2em;
  color: #007593;
  font-weight: bold;
  cursor: pointer;
}

.table-component__filter__field:focus {
  outline: 0;
  border-color: #007593;
}

.table-component__table-wrapper {
  overflow-x: auto;
  margin: 1em 0;
  width: 100%;
  border: solid 1px #ddd;
  border-bottom: none;
}

.table-component__table {
  min-width: 100%;
  border-collapse: collapse;
  border-bottom: solid 1px #ddd;
  table-layout: fixed;
}

.table-component__table__caption {
  position: absolute;
  top: auto;
  left: -10000px;
  overflow: hidden;
  width: 1px;
  height: 1px;
}

.table-component__table th,
.table-component__table td {
  padding: .75em 1.25em;
  vertical-align: top;
  text-align: left;
}

.table-component__table th {
  background-color: #e0e0e0;
  color: #999;
  text-transform: uppercase;
  white-space: nowrap;
  font-size: .85em;
}

.table-component__table tbody tr:nth-child(even) {
  background-color: #f0f0f0;
}

.table-component__table a {
  color: #007593;
}

.table-component__message {
  color: #999;
  font-style: italic;
}

.table-component__th--sort,
.table-component__th--sort-asc,
.table-component__th--sort-desc {
  text-decoration: underline;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.table-component__th--sort-asc:after,
.table-component__th--sort-desc:after {
  position: absolute;
  left: .25em;
  display: inline-block;
  color: #bbb;
}

.table-component__th--sort-asc:after {
  content: '↑';
}

.table-component__th--sort-desc:after {
  content: '↓';
}
</style>
